import { useState } from "react";
import { Accordion, AccordionDetails, AccordionSummary, Box, Stack, Typography } from "@mui/material"
// import { BsFillArrowUpCircleFill } from "react-icons/bs"
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import LinearProgressLine from "../LinearProgressLine"
import GeneButtonList from "../GeneButtonList";

const NutritionAccordion = ({ item }) => {
  const [expanded, setExpanded] = useState(false);
  
  return (
    <Accordion
      expanded={expanded}
      sx={{
        width: '100%',
        backgroundColor: "primary.white",
        boxShadow: '0px 2px 10px 0px #5B87EF33'
      }}
    >
      <AccordionSummary
        aria-controls="medication-content"
        id="medication-header"
        sx={{
          cursor: 'pointer'
        }}
      >
        <Box
          sx={{
            display: 'flex',
            flexDirection: 'column',
            width: '100%'
          }}
        >
          <Box
            sx={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'space-between'
            }}
            onClick={() => setExpanded(!expanded)}
          >
            <Typography variant="h3">
              {item.name}
            </Typography>
            <ExpandMoreIcon
              sx={{
                rotate: expanded ? '180deg' : '0deg',
                color: 'primary.mainBlue'
              }}
            />
          </Box>
          <Typography variant="subText" color="primary.darkGray" mt="4px">
            {item.category}
          </Typography>
          <Box
            sx={{
              display: 'flex',
              flexDirection: 'column',
              py: '24px'
            }}
          >
            <Typography
              variant="subText"
              color="primary.darkGreen"
              sx={{
                color: item?.guidanceLevel === 'High' ? 'primary.red' : item?.guidanceLevel === 'Moderate' ? 'primary.black' : 'primary.mainBlue'
              }}
            >
              Guidance: {item?.guidanceLevel}
            </Typography>
            <LinearProgressLine sx={{ mt: 1 }} level={item?.guidanceLevel} value={item.percent} />
          </Box>
        </Box>
      </AccordionSummary>
      <AccordionDetails>
        <Box
          sx={{
            display: 'flex',
            flexDirection: 'column'
          }}
        >
          <Typography variant="subText" color="primary.darkGray">
            Phenotype
          </Typography>
          <Typography variant="h4" mt={'4px'}>
            {item?.content?.short}
          </Typography>
          <Typography variant="body" color="primary.darkGray" mt={1}>
            {item?.condition}<br/><br/>
            {item?.content?.long}
          </Typography>
          <Stack spacing={'8px'} mt="24px">
            <Box 
              sx={{
                display: 'flex',
                flexDirection: 'column',
                border: '1px solid',
                borderColor: 'primary.mediumGray',
                padding: '8px',
              }}
            >
              <Typography variant="subText" color="primary.darkGray">Gene:</Typography>
              {/* <Typography variant="h4" mt="2px">{item?.genes?.toString()}</Typography> */}
              <Box mt="2px">
                <GeneButtonList genes={item?.genes}/>
              </Box>
            </Box>
            <Box 
              sx={{
                display: 'flex',
                flexDirection: 'column',
                border: '1px solid',
                borderColor: 'primary.mediumGray',
                padding: '8px',
                cursor: 'pointer',

                '&:hover': {
                  borderColor: 'primary.darkGreen',
                  bgcolor: 'primary.lightGreen'
                }
              }}
            >
              <Typography variant="subText" color="primary.darkGray">Genotype:</Typography>
              <Typography variant="h4" mt="2px">{item?.genoType?.toString()}</Typography>
            </Box>
          </Stack>
        </Box>
      </AccordionDetails>
    </Accordion>
  )
}

export default NutritionAccordion